import React from 'react';

const AovProgressBarIcon = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" id="onvoard-icon" viewBox="0 0 900 338">
      <path d="M0 0V337.5H900V0H0ZM843.75 281.25H56.25V56.25H843.75V281.25Z" fill="white"/>
      <path d="M112.5 112.5H506.25V225H112.5V112.5Z" fill="white"/>
    </svg>

  );
}


export { AovProgressBarIcon };
